import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { Dimmer, Loader } from 'semantic-ui-react';
import { useDistributors } from '../../../providers/DistributorProvider';
import { AddButton } from '../../../components/AddButton/AddButton';
import { useAuth } from '../../../providers/AuthenticationProvider';
const WEB_PAGE = 'Distributors';

export const Distributors = () => {
    const { checkAuth, getUserType } = useAuth();
    const [loading, setLoading] = useState(true);
    const { getDistributors, distributors, total, pageIndex, pageSize, sortState, setPageIndex, setPageSize, setSortState } = useDistributors();
    const navigate = useNavigate();

    checkAuth(getUserType(), WEB_PAGE) && navigate('/');

    useEffect(() => {
        setLoading(true);
        const fetchDistributors = async () => {
            await getDistributors();
            setLoading(false);
        }

        fetchDistributors();
    }, [getDistributors]);

    const handlePageChange = (e) => {
        setPageIndex(e.page.skip / e.page.take);
    };

    const handleSortChange = (e) => {
        setSortState(e.sort.length ? [{ fieldName: e.sort[0].field, dir: e.sort[0].dir }] : []);
    };

    const sort = sortState.map(s => ({ field: s.fieldName, dir: s.dir }));

    return (
        <div>
            <div className='pageHeader'>
                <h1>Distributors</h1>
                <AddButton to="/distributors/create-distributor">Create a Distributor</AddButton>
            </div>
            <div style={{ position: 'relative' }}>
                <Dimmer active={loading} inverted>
                    <Loader />
                </Dimmer>
                <Grid
                    data={distributors}
                    total={total}
                    skip={pageIndex * pageSize}
                    take={pageSize}
                    pageable={true}
                    sortable={true}
                    sort={sort}
                    onPageChange={handlePageChange}
                    onSortChange={handleSortChange}
                    onRowClick={(e) => navigate('/distributors/edit/', { state: { distributor: e.dataItem } })}
                >
                    <Column field="name" title="Distributor" />
                    <Column
                        title="Contact Address"
                        sortable={false}
                        cell={props => (
                            <td style={{ textAlign: 'left' }}>
                                {`${props.dataItem.address}, ${props.dataItem.city}, ${props.dataItem.state}, ${props.dataItem.zip}`}
                            </td>
                        )}
                    />
                </Grid>
            </div>
        </div>
    );
};
